module.exports = __webpack_public_path__ + "assets/img/progress-icon.78addfe0.png";